var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 12,
    viewBox: "0 0 2 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0L0.999999 11.5",
    stroke: "#5BC1CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineGreen);
export default __webpack_public_path__ + "static/media/line-green.aa5c0790906285b85bdd3066aba69e87.svg";
export { ForwardRef as ReactComponent };